<template>
    <div class="main-bd mg20 pro-visible">
        <el-row class="searchSection">
            <el-tabs v-model="activeName" @tab-click="handleClick" v-loading="activeLoading">
                <el-tab-pane :label="'全部回款' + '(' + ('0' in active_count ? active_count['0'] : 0) + ')'" name="0"></el-tab-pane>
                <el-tab-pane :label="'准时回款' + '(' + ('1' in active_count ? active_count['1'] : 0) + ')'" name="1"></el-tab-pane>
                <el-tab-pane :label="'超时回款' + '(' + ('2' in active_count ? active_count['2'] : 0) + ')'" name="2"></el-tab-pane>
                <el-tab-pane :label="'逾期回款' + '(' + ('3' in active_count ? active_count['3'] : 0) + ')'" name="3"></el-tab-pane>
                <el-tab-pane :label="'未回款' + '(' + ('4' in active_count ? active_count['4'] : 0) + ')'" name="4"></el-tab-pane>
            </el-tabs>
        </el-row>
        <el-row class="searchSection">
            <el-form ref="form" :inline="true" :model="searcherModel" class="demo-form-inline"
                     :key="$router.currentRoute.path">
                <el-form-item label="客户名称">
                    <CustomerSelect ref="customer" v-model="searcherModel.customer_name"
                                    @change="CustomerHandleChange"></CustomerSelect>
                </el-form-item>
                <el-form-item label="订单负责人" v-if="$route.path=='/order/payment'">
                    <UserSelect ref="user" v-model="searcherModel.salesman" @change="UserHandleChange"></UserSelect>
                </el-form-item>
                <el-form-item label="所属部门">
                    <UserCascader ref="UserCascader" v-model="searcherModel.branch_id" :isBusiness="true" @change="changeBranch"></UserCascader>
                </el-form-item>
                <el-form-item label="订单ID">
                    <el-input size="small" placeholder="订单ID" v-model="searcherModel.order_id"></el-input>
                </el-form-item>

                <el-form-item label="计划回款时间">
                    <el-date-picker
                            size="small"
                            type="daterange"
                            unlink-panels
                            v-model="searcherModel.plan_time"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="回款时间">
                    <el-date-picker
                            size="small"
                            type="daterange"
                            unlink-panels
                            v-model="searcherModel.pay_time"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="录入回款时间">
                    <el-date-picker
                            size="small"
                            type="daterange"
                            unlink-panels
                            v-model="searcherModel.created_time"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="最后操作时间">
                    <el-date-picker
                            size="small"
                            type="daterange"
                            unlink-panels
                            v-model="searcherModel.updated_time"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="订单类型">
                    <el-select size="small" v-model="searcherModel.order_type" placeholder="请选择">
                        <el-option v-for="(item, key) in order_type" :key="key" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" icon="el-icon-search" @click="submitSearch">搜索
                    </el-button>
                    <el-button size="small" @click="resetForm(true)">重置</el-button>
                    <el-button type="primary" size="small" v-if="Acs('/order/export-invoice')" @click="exportInvoice">
                        导出
                    </el-button>
                </el-form-item>
            </el-form>
        </el-row>
        <el-row>
            <div>
                当前页计划回款总金额：<span class="count-amount">{{all_plan_amount}}</span> 
                &nbsp;&nbsp; 
                当前页时间回款总金额：<span class="count-amount">{{all_actual_amount}}</span>
            </div>
            <el-table :data="list" border center style="width: 100%" size="small" :key="$route.path" v-loading="loading" @sort-change="sortChange">
                <el-table-column prop="id" label="回款编号" width="100"></el-table-column>
                <el-table-column prop="order_id" sortable="custom" label="订单ID" width="100">
                    <template slot-scope="scope">
                        <a style="color: #1890ff" @click="toOrder(scope.row)">{{scope.row.order_id}}</a>
                    </template>
                </el-table-column>
                <el-table-column prop="customer_name" label="客户名称" width="280"></el-table-column>
                <el-table-column prop="plan_at" sortable="custom" label="计划回款时间" width="180"></el-table-column>
                <el-table-column prop="plan_amount" label="计划回款金额">
                    <template slot-scope="scope">
                        {{scope.row.sensitive_masked ? '******' : _.round(scope.row.plan_amount, 2)}}
                    </template>
                </el-table-column>
                <el-table-column prop="actual_at" sortable="custom" label="实际回款时间" width="180"></el-table-column>
                <el-table-column prop="actual_amount" label="实际回款金额"></el-table-column>
                <el-table-column prop="created_at" sortable="custom" label="录入回款时间" width="200">
                    <template slot-scope="scope">
                        {{scope.row.created_at_memo}}
                    </template>
                </el-table-column>
                <el-table-column prop="type" label="回款类型"></el-table-column>
                <el-table-column prop="no_pay" label="订单未回款金额">
                    <template slot-scope="scope">
                        {{scope.row.sensitive_masked ? '******' : (scope.row.no_pay == 0 ? '回款已完成' : _.round(scope.row.no_pay, 2))}}
                    </template>
                </el-table-column>
                <el-table-column prop="updated_at" sortable="custom" label="最后操作时间" width="180">
                    <template slot-scope="scope">
                        {{scope.row.updated_at_memo}}
                    </template>
                </el-table-column>
                <el-table-column prop="sale_man" label="销售负责人"></el-table-column>
                <el-table-column prop="address" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" @click="show(scope.row)" size="small">查看详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <el-row v-if="linkPage">
            <pagination :linkPage="linkPage"></pagination>
        </el-row>


        <el-dialog title="回款详情" :visible.sync="dialogVisible" width="42%" center>
            <h4>基本信息</h4>
            <p>编号：{{form.id}}</p>
            <p>录入回款时间：{{form.created_at_memo}}</p>
            <p>录入人:{{form.recorder}}</p>
            <h4>详情</h4>
            <p>所属订单：{{form.order_id}}</p>
            <p>销售负责人：{{form.sale_man}}</p>
            <p>对应客户：{{form.customer_name}}</p>
            <table border="1" width="700">
                <tr>
                    <th>计划回款金额</th>
                    <th>计划回款时间</th>
                    <th>实际回款金额</th>
                    <th>实际回款时间</th>
                    <th>未回款金额</th>
                    <th>最后操作时间</th>
                </tr>
                <tr>
                    <td>{{form.plan_amount}}</td>
                    <td>{{form.plan_at}}</td>
                    <td>{{form.actual_amount}}</td>
                    <td>{{form.actual_at}}</td>
                    <td>{{form.no_pay}}</td>
                    <td>{{form.updated_at_memo}}</td>
                </tr>
            </table>
            <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false">关 闭</el-button>
             </span>
        </el-dialog>
    </div>
</template>
<style scoped>
    .count-amount{
        color: red;
        font-weight: 700;
    }
</style>
<script>
    import UserSelect from "~/widgets/UserSelect.vue";
    import CustomerSelect from "~/widgets/CustomerSelect.vue";
    import Pagination from "~/widgets/Pagination.vue";
    import OrderService from "~/services/order";
    import UserCascader from "~/widgets/UserCascader.vue";
    import ExportFile from "~/widgets/ExportFile.vue";
    import Config from "~/config/params";
    export default {
        name: "invoice",
        components: {
            UserSelect,
            CustomerSelect,
            Pagination,
            UserCascader,
            ExportFile,
            Config
        },
        data() {
            return {
                list: [],
                loading: true,
                linkPage: null,
                dialogVisible: false,
                form: {},
                searcherModel: {
                    pay_time: [],
                    plan_time: [],
                    created_time: [],
                    updated_time: [],
                    customer_name: '',
                    salesman: '',
                    order_id: '',
                    user_id: '',
                    sort: '',
                    branch_id: '',
                    route: this.$route.path,
                    order_type: '',
                },
                invoice_status: [
                    {
                        value: 2,
                        label: '全部'
                    }, {
                        value: 0,
                        label: '否'
                    }, {
                        value: 1,
                        label: '是'
                    }
                ],
                invoice_issue: [
                    {
                        value: 2,
                        label: '全部'
                    }, {
                        value: 0,
                        label: '未开票'
                    }, {
                        value: 1,
                        label: '已开票'
                    }
                ],
                activeName: '0',
                active_count: {},
                order_type: [{
                    value: 0,
                    label: '不限',
                },
                {
                    value: Config.TYPE_TRY_OUT,
                    label: '试用',
                }, 
                {
                    value: Config.TYPE_FORMAL,
                    label: '正式(新单)'
                }, 
                {
                    value: Config.TYPE_RENEW,
                    label: '正式(续单)'
                },
                {
                    value: Config.TYPE_FORMAL_AND_RENEW,
                    label: '正式'
                }],
                activeLoading: false,
            }
        },
        // 监听路由参数更新执行分页请求
        beforeRouteUpdate: function (to, from, next) {
            let params = this.searcherModel;
            params['page'] = to.query["page"];
            params['perPage'] = to.query["perPage"];
            this.getList(params);
        },
        created() {
            this.getPaymentCount({route: this.$route.path});
            this.getList(this.searcherModel);
        },
        watch: {
            $route(to, from) {
                this.resetForm();
                this.activeName = '0';
                let params = this.searcherModel;
                console.log(this.searcherModel);
                params['page'] = to.query["page"];
                params['perPage'] = to.query["perPage"];
                this.getPaymentCount({route: this.$route.path});
                this.getList(params);
            },
        },
        computed: {
            isOrderSensitiveMasked() {
                return this.list.some(item => item.sensitive_masked || item.order_sensitive_masked);
            },
            all_plan_amount() {
                if (this.isOrderSensitiveMasked) {
                    return '******';
                }
                return this.list.reduce((sum, item) => sum + parseFloat(item.plan_amount), 0);
            },
            all_actual_amount() {
                if (this.isOrderSensitiveMasked) {
                    return '******';
                }
                return this.list.reduce((sum, item) => sum + parseFloat(item.actual_amount), 0);
            },
        },
        methods: {
            toCustomer(row) {
                let path = "/customers/view";
                let data = this.$router.resolve({
                    url: "/customers/view",
                    name: "/order/view",
                    path: path,
                    query: {
                        id: row.customer_id
                    }
                });
                window.open(data.href, '_blank');
            },
            toOrder(row) {
                let path = "/order/view";
                let data = this.$router.resolve({
                    url: "/order/view",
                    name: "/order/view",
                    path: path,
                    query: {
                        id: row.order_id
                    }
                });
                window.open(data.href, '_blank');
            },
            exportInvoice() {
                const params = [];
                if (this.$route.path == '/order/my-payment') {
                    this.searcherModel.user_id = this.$store.getters.userId;
                }
                let obj = this.searcherModel;
                obj['type'] = this.activeName;
                let filter_key = ['time', 'pay_time', 'created_time', 'updated_time'];
                Object.keys(obj).forEach((key) => {
                    if (filter_key.includes(key) && obj[key].length > 0) {
                        let new_key = key + '[]';
                        let value1 = new Date(obj[key][0]).toLocaleDateString();
                        let value2 = new Date(obj[key][1]).toLocaleDateString();
                        params.push([new_key, encodeURIComponent(value1)].join('='));
                        params.push([new_key, encodeURIComponent(value2)].join('='));
                        return;
                    }
                    let value = obj[key];
                    params.push([key, encodeURIComponent(value)].join('='))
                })
                let str = params.join('&');
                let url = 'api/order/export-payment?access-token=' + this.$store.getters.token + '&';
                let elemIF = document.createElement("iframe");
                elemIF.width = 0;
                elemIF.height = 0;
                elemIF.src = url + str;
                elemIF.style.display = "none";
                document.body.appendChild(elemIF);
            },
            show(form) {
                this.form = form;
                this.dialogVisible = true;
            },
            resetForm(is_searcher = false) {
                this.searcherModel = {
                    pay_time: [],
                    created_time: [],
                    customer_name: '',
                    salesman: '',
                    order_id: '',
                    user_id: '',
                    branch_id: '',
                };
                if (this.$refs['user']) {
                    this.$refs['user'].reset();
                }
                this.$refs['customer'].reset();
                this.$refs["UserCascader"].reset();
                if (is_searcher) {
                    this.getList({});
                }
            },
            submitSearch() {
                this.getList(this.searcherModel);
            },
            getList(params = {}) {
                this.loading = true;
                let payment = '';
                params.is_pay = 0;
                params.type = this.activeName;
                if (this.$route.path == '/order/my-payment') {
                    payment = OrderService.myPayment(params);
                } else {
                    payment = OrderService.payment(params)
                }
                payment.then(res => {
                    this.loading = false;
                    this.list = res.data;
                    if (res._meta) {
                        this.linkPage = res._meta;
                    }
                });
            },
            //业务员姓名远程搜索组件赋值
            UserHandleChange(object) {
                this.searcherModel.salesman = object.value;
            },
            //客户名称远程搜索组件赋值
            CustomerHandleChange(object) {
                this.searcherModel.customer_name = object.value;
            },

            sortChange(obj) {
                let sort = '';
                if (obj.prop && obj.prop != null) {
                    switch (obj.order) {
                        case 'ascending':
                            sort = ''
                            break;
                        case 'descending':
                            sort = '-';
                            break;
                        default:
                            // 默认倒序
                            sort = '-';
                            break;
                    }
                    sort = sort + obj.prop;
                }

                this.searcherModel.sort = sort;
                this.getList(this.searcherModel);
            },

            changeBranch(value) {
                if (value.length > 0) {
                    // 取得最后一级部门作为所属部门
                    this.searcherModel.branch_id = value[value.length - 1];
                } else {
                    this.searcherModel.branch_id = "";
                }
            },

            handleClick: function (tab) {
                this.resetForm(true)
            },

            // 获取回款统计
            getPaymentCount(params = {}) {
                // 全部线索
                this.activeLoading = true;
                OrderService.paymentCount(params).then(res => {
                    if (res.code == 0) {
                        this.active_count = res.data;
                    }
                    this.activeLoading = false;
                }).catch(err => {
                    this.activeLoading = false;
                    console.error(err)
                })
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/pay/list.vue